import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const getParticularchannelAdminAPI = createAsyncThunk(
  "auth/channelAdmin/getPaticular",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.get(
        apiRoutes.channelAdminAction("details",1,id,1)
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" };
const getparticularDetailschannelAdminSlice = createSlice({
  name: "get particular channelAdmin",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetgetparticularchannelAdmin: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getParticularchannelAdminAPI.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getParticularchannelAdminAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(getParticularchannelAdminAPI.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetgetparticularchannelAdmin } = getparticularDetailschannelAdminSlice.actions;
export const getparticularDetailschannelAdminReducer =
  getparticularDetailschannelAdminSlice.reducer;
